import { useState } from "react";
import "./App.css";
import Navbar from "./Main/Components/Navbar";
import HomeScreen from "./Main/Screens/HomeScreen";
import { Box } from "@mui/material";
import Evaluation from "./Main/Screens/Evaluation/Evaluation";
import LoginScreen from "./Main/Screens/LoginScreen";

function App() {
  const [screenNo, setScreenNo] = useState(-1);
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [company, setCompany] = useState('Walmart');
  const [insuranceType, setInsuranceType] = useState('Dental');
  const ToEvaluation = (company, type) => {
    setScreenNo(1);
    setCompany(company);
    setInsuranceType(type)
  };
  const ToHome = () => {
    setScreenNo(0);
  };
  return (
    <>
      {isLoggedIn ? (<> <Navbar ToHome={ToHome} />
        <Box sx={{ height: "70px" }}></Box>

        {screenNo === 0 && <HomeScreen ToEvaluation={ToEvaluation} />}
        {screenNo === 1 && <Evaluation ToHome={ToHome} company={company} insuranceType={insuranceType} />}</>)
        : (<LoginScreen ToHome={() => {
          setScreenNo(0);
          setLoggedIn(true);
        }} />
        )}

    </>
  );
}

export default App;
